module.exports = __webpack_public_path__ + "img/favicon.e5fed83.png";